<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Merchants Admin</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" @click="newMerchant()">New Merchant</a>
					<a href="#" @click="saveMerchant()" v-if="merchant">Save</a>
					<a href="#" @click="deleteMerchant()" v-if="merchant">Delete</a>
					<a href="#" @click="onLoad()" v-if="merchant">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<div class="row">
			<div class="col-md-3">
				<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
				<div class="leftSide">
					<b-table :filter="search" striped hover small :items="merchants" selectable select-mode="single" :fields="['merchants']" @row-clicked="selectMerchant"></b-table>
				</div>
			</div>
			<div class="col-md-8 m-3 mt-0" v-if="merchant">
				<div class="row mb-2">
					<h4>{{merchant.id}}</h4>
				</div>
				<div class="row mb-2">
					<div class="col-md-4">
						Name: <b-form-input class="mb-2" v-model="merchant.name"></b-form-input>
					</div>
					<div class="col-md-4">
						Regex: <b-form-input class="mb-2" v-model="merchant.regex"></b-form-input>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-md-4">
						Regex Exclude: 
						<b-icon-question-circle 
							id="regex-exclude-tooltip" 
							class="ml-1"
							variant="secondary"
						></b-icon-question-circle>
						<b-tooltip target="regex-exclude-tooltip" placement="top">
							If the merchant matches on the regex above, but then also matches this regex, it will be excluded from well known merchant matching.
						</b-tooltip>
						<b-form-input class="mb-2" v-model="merchant.regexExclude"></b-form-input>
					</div>
					<div class="col-md-4">
						<!-- Moved explanatory text to tooltip -->
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-md-4">
						Lower Limit: <b-form-input class="mb-2" v-model="merchant.lowerLimit"></b-form-input>
					</div>
					<div class="col-md-4">
						Upper Limit: <b-form-input class="mb-2" v-model="merchant.upperLimit"></b-form-input>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-md-2">
						Utility: <b-form-checkbox class="mb-2" v-model="merchant.utilityProvider"></b-form-checkbox>
					</div>
					<div class="col-md-2">
						Switch Deal: <b-form-checkbox class="mb-2" v-model="merchant.switchDealAvailable"></b-form-checkbox>
					</div>
					<div class="col-md-2">
						Not Recurring: <b-form-checkbox class="mb-2" v-model="merchant.notRecurring"></b-form-checkbox>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-md-12">
						Voucher Available: {{ getDiscountString(merchant.discount) }}
					</div>
				</div>
				
				<b-row>
					<b-col>
						Classification: 
					</b-col>
				</b-row>
				<div class="row mb-2">
					<div class="col-md-7" v-if="merchant.transactionClassification">
						<b-form-input readonly class="mb-2" v-model="merchant.transactionClassification.fullName"></b-form-input>
					</div>
					<div class="col-md-1">
						<b-button v-b-toggle.classificationsSidebar size="sm">Classify</b-button>
					</div>
				</div>
				<b-sidebar id="classificationsSidebar" class="sidebar" title="Classifications" bg-variant="dark" right shadow>
					<div class="px-3 py-2">
						
						<div v-for="p in transactionClassifications" :key="p.id">
							<b-button v-b-modal.modal-confirm @click="catClicked(p)" class="parent-cat">{{p.mgClassification.mgClassification}}</b-button>
							<b-button v-b-modal.modal-confirm @click="catClicked(c)" class="child-cat" size="sm" v-for="c in p.children" :key="c.mgClassification.id">{{c.mgClassification.mgSubClassification}}</b-button>
						</div>
						
					</div>
				</b-sidebar>

			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'Merchants',
  data() {
	return{
		merchants: null,
		merchant: null,
		discounts: null,
		transactionClassifications: null,
		search: "",
		showDiscount: false,
		merchantDiscount: null,
		merchantDiscountRequest: { merchantName: "", discountPercentage: 0, sysoMerchantId: null }
	}
  },
  methods: {
	list: function(){
		this.$http.get(this.$config.ApiUri + "/Merchants")
			.then((result) => {
				this.merchants = result.data;
				for (var x = 0; x< this.merchants.length; x++)
				{
					this.merchants[x].merchants = this.merchants[x].name;
				}
			}
		)
	},
	getDiscountString: function(discount){
		if (discount) {
			let discountType = "";
			if (discount.online && discount.inStore) {
				discountType = "Online & In Store";
			} else if (discount.online) {
				discountType = "Online";
			} else if (discount.inStore) {
				discountType = "In Store";
			}
			return discount.discountPercentage + "% " + discountType;
		}
		return "";
	},
	catClicked: function(sel){
		this.merchant.transactionClassification = sel.mgClassification;
		this.$forceUpdate();
		this.merchant.setTransactionClassificationID = sel.mgClassification.id;
	},
	onLoad() {
		this.list();
		this.getTransactionClassifications();
	},
	saveMerchant(){
		if (!this.merchant.switchDealAvailable) { this.merchant.switchDealAvailable = false; }
		if (!this.merchant.voucherAvailable) { this.merchant.voucherAvailable = false; }
		if (!this.merchant.cashbackAvailable) { this.merchant.cashbackAvailable = false; }
		if (!this.merchant.utilityProvider) { this.merchant.utilityProvider = false; }
		if (!this.merchant.notRecurring) { this.merchant.notRecurring = false; }
		if (this.merchant.id != null) {
			this.$http.put(this.$config.ApiUri + "/Merchants/" + this.merchant.id, this.merchant)
				.then((result) => {
					this.merchant = result.data;
				}
			)
		} else {
			this.$http.post(this.$config.ApiUri + "/Merchants", this.merchant)
				.then((result) => {
					this.merchant = result.data;
					this.list();
				}
			)
		}
	},
	deleteMerchant(){
		this.$http.delete(this.$config.ApiUri + "/Merchants/" + this.merchant.id)
			.then(() => {
				this.list();
				this.merchant = null;
				if (this.merchants.length > 0){
					this.selectMerchant(this.merchants[0]);
				}
			}
		)
	},
	newMerchant(){
		this.merchant = {
			name: "",
			regex: "",
			setTransactionClassificationID: null,
			upperLimit: null,
			lowerLimit: null,
			utilityProvider: false,
			notRecurring: false,
			switchDealAvailable: false,
		}
		this.showDiscount = false;
	},
	selectMerchant(e){
		this.merchant = e;
		this.merchantDiscountRequest.merchantName = this.merchant.name;
		this.merchantDiscountRequest.sysoMerchantId = this.merchant.id;
		this.findSelectedMerchantDiscount();
	},
	findSelectedMerchantDiscount(){
		if (this.discounts) {
			for (var x = 0; x < this.discounts.length; x++) {
				if (this.discounts[x].merchant.sysoMerchantId == this.merchant.id) {
					this.merchantDiscount = this.discounts[x];
					this.merchantDiscountRequest.discountPercentage = this.merchantDiscount.discountPercentage;
					this.showDiscount = true;
					return;
				}
			}
		}
		this.merchantDiscountRequest.discountPercentage = 0;
		this.showDiscount = false;
	},
	getTransactionClassifications(){
		this.$http.get(this.$config.ApiUri + "/TransactionClassifications")
			.then((result) => {
				this.transactionClassifications = result.data;
			}
		)
	},
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style scoped="true">
	.child-cat {
		margin:3px;
		background-color: rgb(104, 84, 150);
	}
	.parent-cat {
		margin:3px;
		background-color: rgb(53, 43, 77);
	}

</style>